const css = `._1LyyCW__userInfo{min-width:150px;flex:2 40%}._1LyyCW__nameAndSummary{text-overflow:ellipsis;white-space:nowrap;width:100%;display:inline-block;overflow:hidden}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"userInfo":"_1LyyCW__userInfo","nameAndSummary":"_1LyyCW__nameAndSummary"};
